import { render, staticRenderFns } from "./FormGroupItem.vue?vue&type=template&id=87458272&scoped=true"
import script from "./FormGroupItem.vue?vue&type=script&lang=js"
export * from "./FormGroupItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87458272",
  null
  
)

export default component.exports